<template>
  <div
    class="w-full h-full flex justify-center items-center overflow-hidden"
    :class="currentTheme === 'dark' ? 'bg-[#262727]' : 'bg-[#f8f8f9]'"
  >
    <div class="wscn-http404 flex">
      <div class="pic-404 mr-50px">
        <img src="@/assets/images/404.png" alt="404" />
      </div>
      <div class="bullshit flex justify-center  flex-col">
        <div
          class="bullshit__oops text-90px font-bold"
          :class="currentTheme === 'dark' ? 'text-[#fff]' : 'text-[#303133]'"
        >
          404
        </div>
        <div
          class="bullshit__info text-14px mt-10px"
          :class="currentTheme === 'dark' ? 'text-[#C4CDDA]' : 'text-[#515A6E]'"
        >
          <div>很抱歉，您要访问的页面地址有误，</div>
          <div class="mt-10px">或者该页面不存在。</div>
        </div>
        <div class="flex mt-20px">
          <el-button size="small" type="primary" @click="back">
            返回上一页
          </el-button>
          <el-button size="small" type="primary" @click="backDefaultPath">
            返回首页
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Page404',
  computed: {
    message() {
      return `redirectedFrom: ${this.$route.redirectedFrom}`
    },
    currentLang() {
      return this.$store.getters['System/currentLang']
    },
    ...mapGetters({
      defaultPath: 'Auth/defaultPath',
    }),
    currentTheme() {
      return this.$store.getters['System/currentTheme']
    },
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    backDefaultPath() {
      this.$router.push({
        path: this.defaultPath,
      })
    },
  },
  created() {
    console.log(this.$router, 'route-1')
    if (this.currentLang === 'en') {
      this.$i18n.locale = 'en'
    } else {
      this.$i18n.locale = 'zh'
    }
  },
}
</script>
